
import { Union, Record } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ApiReceiver_$reflection } from "../../../../Shared/User.js";
import { union_type, class_type, record_type, list_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { RequestedValue$1_$reflection } from "../../../../Shared/Shared.js";

export class State extends Record {
    constructor(ApiReceivers) {
        super();
        this.ApiReceivers = ApiReceivers;
    }
}

export function State_$reflection() {
    return record_type("Settings.UserManagement.ApiReceiver.Overview.Types.State", [], State, () => [["ApiReceivers", RequestedValue$1_$reflection(list_type(ApiReceiver_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ApiReceiversFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.UserManagement.ApiReceiver.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(ApiReceiver_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

